module.exports = __webpack_public_path__ + "img/spiny_lobster.e8ce2015.png";